import React from "react"
import { analytics } from "utils/analytics"
import { useVerticalNavOptIn } from "./use-vertical-nav-optin"

// Each `start` is the instant that week's copy takes over, at 10:00 AM Eastern.
// The explicit -04:00 offset (EDT — all four dates fall in daylight time) makes
// the comparison an absolute instant, so the transition happens at the same
// moment regardless of the viewer's timezone.

const FEEDBACK_URL = "https://kit.typeform.com/to/BMYK4vQO"

const FeedbackLink = ({ children }) => (
  <a
    href={FEEDBACK_URL}
    target="_blank"
    rel="noreferrer"
    className="font-semibold underline"
  >
    {children}
  </a>
)

const SwitchNavLink = ({ children }) => {
  const { enableVerticalNav } = useVerticalNavOptIn()

  const handleClick = () => {
    analytics.track(
      "Element",
      "Clicked",
      {
        element_type: "link",
        name: "sunset_hint_switch_to_new_navigation",
        text: children,
        location: "sunset_hint"
      },
      { transport: "beacon" }
    )
    enableVerticalNav()
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="font-semibold underline"
    >
      {children}
    </button>
  )
}

export const SUNSET_HINT_WEEKS = [
  {
    start: "2026-07-20T10:00:00-04:00",
    title: "We've improved our new navigation",
    description: (
      <>
        {
          "We've made a lot of improvements based on your feedback. Give it a try and "
        }
        <FeedbackLink>share what you think</FeedbackLink>.
      </>
    )
  },
  {
    start: "2026-07-27T10:00:00-04:00",
    title: "3 weeks until the new navigation",
    description: (
      <>
        {
          "Kit's new navigation will become the default on August 20. Creators found what they needed 40% faster with this update. "
        }
        <SwitchNavLink>Try it out</SwitchNavLink>.
      </>
    )
  },
  {
    start: "2026-08-03T10:00:00-04:00",
    title: "2 weeks to go",
    description: (
      <>
        {"Kit's new navigation becomes the default on August 20. "}
        <SwitchNavLink>Turn it on now</SwitchNavLink>
        {" and share your feedback."}
      </>
    )
  },
  {
    start: "2026-08-10T10:00:00-04:00",
    title: "One more week",
    description: (
      <>
        {"Kit's new navigation becomes the default on August 20. "}
        <SwitchNavLink>Turn it on now</SwitchNavLink>
        {" to familiarize yourself by the time it switches over."}
      </>
    )
  }
]

export function currentSunsetWeek(now = new Date()) {
  let current = null
  for (const week of SUNSET_HINT_WEEKS) {
    if (now >= new Date(week.start)) current = week
  }
  return current
}
